export default __webpack_public_path__ + "static/media/check.33d58608.svg";